<template>
    <b-modal centered ref="modal" hide-header-close>
        <template #modal-header>
            <div class="mx-auto">
                <h5 class="text-primary font-20 font-weight-bold">{{ contactDetailsLabel }} Contact Details</h5>
            </div>
        </template>
        <div>
            <div>
                <p class="font-weight-bold font-14">
                    Dealer Details
                </p>
                <div class="row">
                    <div class="col-3">
                        <div>
                            <img :src="company.logo ? company.logo : '/images/Avatar.png'"
                                 :alt="company.name"
                                 class="rounded-circle logo-image"
                                 data-holder-rendered="true">
                        </div>
                   </div>
                    <div class="col-9 pt-1">
                        <div class="font-14 font-weight-normal">
                            <i class="mdi mdi-map-marker pr-2"></i><span class="font-weight-bold">Address: </span>{{ company.address }}<br/>
                            <i class="mdi mdi-email pr-2"></i><span class="font-weight-bold">Email: </span><a :href="`mailto:+${company.email}`">{{ company.email }}</a><br/>
                            <i class="mdi mdi-phone pr-2"></i><span class="font-weight-bold">Phone Number: </span> <a :href="`tel:${company.phone_number}`" class="underline">{{ company.phone_number }}</a><br/>
                        </div>
                    </div>
                </div>
                <hr />
            </div>
            <div>
                <p class="font-weight-bold font-14">
                    Sales Manager Details
                </p>
                <div v-for="(salesManager, index) in salesManagerUsers" :key="salesManager.id">
                    <div class="row">
                        <div class="col-3">
                            <div>
                                <img :src="salesManager.avatar ? salesManager.avatar : '/images/Avatar.png'"
                                     :alt="salesManager.name"
                                     class="rounded-circle logo-image"
                                     data-holder-rendered="true">
                            </div>
                        </div>
                        <div class="col-9 pt-1">
                            <div class="font-14 font-weight-normal">
                                <i class="mdi mdi-account pr-2"></i><span class="font-weight-bold">Name: </span>{{ salesManager.name }}<br/>
                                <i class="mdi mdi-email pr-2"></i><span class="font-weight-bold">Email: </span><a :href="`mailto:${salesManager.email}`">{{ salesManager.email }}</a><br/>
                                <i class="mdi mdi-phone pr-2"></i><span class="font-weight-bold">Phone Number: </span> <a :href="`tel:${salesManager.phone_number}`" class="underline">{{ salesManager.phone_number }}</a><br/>
                            </div>
                        </div>
                    </div>
                  <hr v-if="index !== salesManagerUsers.length - 1"/>
                </div>
            </div>
        </div>
        <div slot="modal-footer">
            <b-button variant="primary" @click="$refs.modal.hide()">Back</b-button>
        </div>
    </b-modal>
</template>

<script>
import AvatarIcon from "@/components/main/icons/AvatarIcon";
import Roles from "@/constants/roles";

export default {
    components: {
        AvatarIcon,
    },
    props: {
        company: {
            required: true,
            type: Object,
        },
        enquiryHandlers: {
            required: true,
            type: Array,
        },
        isSeller: {
            required: true,
            type: Boolean,
        },
    },
    methods: {
        show() {
            this.$refs.modal.show();
        },
        hide() {
            this.$refs.modal.hide();
        },
    },
    computed: {
        salesManagerUsers() {
            return this.enquiryHandlers
        },
        contactDetailsLabel() {
            return this.isSeller ? 'Buyer\'s' : 'Seller\'s';
        },
    },
}
</script>
<style scoped>
.underline {
  text-decoration: underline;
}
.logo-image {
  width: 75px;
  height: 75px;
  object-fit: cover;
}
</style>
